<template>

    <div class="app-container" v-if="canList">
        <div class="filter-container">
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="店主名"
                      v-model="listQuery.name">
            </el-input>
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="店铺姓名"
                      v-model="listQuery.shopName">
            </el-input>
<!--            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                      placeholder="店铺地址"-->
<!--                      v-model="listQuery.shopAddress">-->
<!--            </el-input>-->
<!--            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                      placeholder="店主地址"-->
<!--                      v-model="listQuery.userAddress">-->
<!--            </el-input>-->
<!--            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                      placeholder="店主身份证"-->
<!--                      v-model="listQuery.card">-->
<!--            </el-input>-->
<!--            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                      placeholder="店铺联系方式"-->
<!--                      v-model="listQuery.shopPhone">-->
<!--            </el-input>-->
<!--            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                      placeholder="店主联系电话"-->
<!--                      v-model="listQuery.userPhone">-->
<!--            </el-input>-->
<!--            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                      placeholder="管理者联系电话"-->
<!--                      v-model="listQuery.managePhone">-->
<!--            </el-input>-->
<!--            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                      placeholder="店铺标语"-->
<!--                      v-model="listQuery.slogan">-->
<!--            </el-input>-->
<!--            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                      placeholder="管理者姓名"-->
<!--                      v-model="listQuery.manageName">-->
<!--            </el-input>-->
<!--            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                      placeholder="管理者编号"-->
<!--                      v-model="listQuery.mcode">-->
<!--            </el-input>-->
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="用户编号"
                      v-model="listQuery.userCode">
            </el-input>
            <el-select @change='handleFilter' clearable class="filter-item input" style="width: 130px"
                       v-model="listQuery.status"
                       placeholder="状态">
                <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item" :value="index">
                </el-option>
            </el-select>

            <div style="display: inline-block">

                <el-button style="margin-left: 10px;" class="filter-item" type="primary" v-waves icon="el-icon-search"
                           @click="handleFilter">查找
                </el-button>
<!--                <el-button class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary"-->
<!--                           v-if="canSave" icon="el-icon-edit">添加-->
<!--                </el-button>-->
<!--                <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-download"-->
<!--                           @click="handleDownload">导出-->
<!--                </el-button>-->
            </div>
        </div>

        <el-table :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;">
            <el-table-column align="center" label="序号">
                <template slot-scope="scope">
                    <span>{{scope.row.id}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="店铺名">
                <template slot-scope="scope">
                    <span>{{scope.row.shopName}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="店主姓名">
                <template slot-scope="scope">
                    <span>{{scope.row.name}}</span>
                </template>
            </el-table-column>
<!--            <el-table-column align="center" label="店铺地址">-->
<!--                <template slot-scope="scope">-->
<!--                    <span>{{scope.row.shopAddress}}</span>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column align="center" label="店主地址">-->
<!--                <template slot-scope="scope">-->
<!--                    <span>{{scope.row.userAddress}}</span>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column align="center" label="店主身份证">-->
<!--                <template slot-scope="scope">-->
<!--                    <span>{{scope.row.card}}</span>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column align="center" label="店铺联系方式">
                <template slot-scope="scope">
                    <span>{{scope.row.shopPhone}}</span>
                </template>
            </el-table-column>
<!--            <el-table-column align="center" label="店主联系电话">-->
<!--                <template slot-scope="scope">-->
<!--                    <span>{{scope.row.userPhone}}</span>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column align="center" label="管理者联系电话">-->
<!--                <template slot-scope="scope">-->
<!--                    <span>{{scope.row.managePhone}}</span>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column align="center" label="店铺标语">-->
<!--                <template slot-scope="scope">-->
<!--                    <span>{{scope.row.slogan}}</span>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column align="center" label="管理者姓名">-->
<!--                <template slot-scope="scope">-->
<!--                    <span>{{scope.row.manageName}}</span>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column align="center" label="管理者编号">-->
<!--                <template slot-scope="scope">-->
<!--                    <span>{{scope.row.mcode}}</span>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column align="center" label="用户编号">
                <template slot-scope="scope">
                    <span>{{scope.row.userCode}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="状态">
                <template slot-scope="scope">
                                                <span>

                         <el-tag :type="tagTypes[scope.row.status]">     {{statusOptions[scope.row.status]}}</el-tag>

                        </span>
                </template>
            </el-table-column>

            <el-table-column align="center" label="操作" width="230" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button type="primary" v-if="canUpdate" size="mini" @click="handleUpdate(scope)">编辑</el-button>
                    <el-button v-if="canSave" size="mini" type="danger"
                               @click="handleDelete(scope)">删除
                    </el-button>
                </template>
            </el-table-column>

        </el-table>

        <div class="pagination-container" style="margin-top: 20px">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <el-form :rules="rules" ref="dataForm" :model="temp" label-position="left" label-width="120px"
                     style='width: 450px; margin-left:50px;'>
                <el-form-item label="店铺名" prop="shopName">
                    <el-input v-model="temp.shopName"></el-input>
                </el-form-item>
<!--                <el-form-item label="店铺地址" prop="shopAddress">-->
<!--                    <el-cascader-->
<!--                            :props="props"-->
<!--                            v-model="selectedOptions"-->
<!--                            :clearable="true"-->
<!--                            :filterable="true"-->
<!--                            :options="addressData"-->
<!--                            @change="handleChange"-->
<!--                    ></el-cascader>-->
<!--                    <el-input v-model="temp.shopAddress" placeholder="请填写详细地址"></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="店主地址" prop="userAddress">-->
<!--                    <el-input v-model="temp.userAddress"></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="店主身份证" prop="card">-->
<!--                    <el-input v-model="temp.card"></el-input>-->
<!--                </el-form-item>-->
                <el-form-item label="店铺联系方式" prop="shopPhone">
                    <el-input v-model="temp.shopPhone"></el-input>
                </el-form-item>
              <el-form-item label="店主姓名" prop="name">
                <el-input v-model="temp.name"></el-input>
              </el-form-item>
<!--                <el-form-item label="店主联系电话" prop="userPhone">-->
<!--                    <el-input v-model="temp.userPhone"></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="管理者联系电话" prop="managePhone">-->
<!--                    <el-input v-model="temp.managePhone"></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="店铺标语" prop="slogan">-->
<!--                    <el-input v-model="temp.slogan"></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="管理者姓名" prop="manageName">-->
<!--                    <el-input v-model="temp.manageName"></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="管理者编号" prop="mcode">-->
<!--                    <el-input v-model="temp.mcode"></el-input>-->
<!--                </el-form-item>-->
                <el-form-item label="用户编号" prop="userCode">
                    <el-input v-model="temp.userCode"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-select class="filter-item" v-model="temp.status" placeholder="状态">
                        <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item"
                                   :value="index">
                        </el-option>
                    </el-select>
                </el-form-item>
<!--                <el-form-item label="是否开通智慧门店" prop="status">-->
<!--                    <el-select class="filter-item" v-model="temp.type" placeholder="状态">-->
<!--                        <el-option v-for="(item,index) in  typeOptions" :key="item" :label="item"-->
<!--                                   :value="index">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
<!--                <div v-if="temp.type==1">-->
<!--                    <el-form-item label="店铺地址经度" prop="lng">-->
<!--                        <el-input v-model="temp.lng"></el-input>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item label="店铺地址纬度" prop="lat">-->
<!--                        <el-input v-model="temp.lat"></el-input>-->
<!--                    </el-form-item>-->
<!--                </div>-->

<!--                <el-form-item v-if="temp.type == 1" label="营业时间(如:7:00-8:00)" prop="businessHours">-->
<!--                    <el-input v-model="temp.businessHours" placeholder="请填写营业时间"></el-input>-->
<!--                </el-form-item>-->
<!--              <el-form-item v-if="temp.status===2" label="备注" prop="remark">-->
<!--                <el-input v-model="temp.remark"></el-input>-->
<!--              </el-form-item>-->
                <el-form-item label="店铺门头" prop="avatar">
                    <el-upload
                            ref="avatarUpload"
                            action="https://upload.qiniup.com"
                            :auto-upload="true"
                            list-type="picture-card"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="handleUpload"
                            :file-list="avatarList"
                            :on-success="(response, file, fileList)=>handleImgUploadSuccess(avatarList,file)"
                            :data="qData"
                            :on-remove="(file, fileList)=>handleImgRemove(avatarList,file)">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
<!--                <el-form-item label="店主证件反面照" prop="cardImg">-->
<!--                    <el-upload-->
<!--                            ref="cardImgUpload"-->
<!--                            action="https://upload.qiniup.com"-->
<!--                            :auto-upload="true"-->
<!--                            list-type="picture-card"-->
<!--                            :on-preview="handlePictureCardPreview"-->
<!--                            :before-upload="handleUpload"-->
<!--                            :file-list="cardImgList"-->
<!--                            :on-success="(response, file, fileList)=>handleImgUploadSuccess(cardImgList,file)"-->
<!--                            :data="qData"-->
<!--                            :on-remove="(file, fileList)=>handleImgRemove(cardImgList,file)">-->
<!--                        <i class="el-icon-plus"></i>-->
<!--                    </el-upload>-->
<!--                </el-form-item>-->
                <el-form-item label="店铺营业执照图" prop="shopbusImg">
                    <el-upload
                            ref="shopbusImgUpload"
                            action="https://upload.qiniup.com"
                            :auto-upload="true"
                            list-type="picture-card"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="handleUpload"
                            :file-list="shopbusImgList"
                            :on-success="(response, file, fileList)=>handleImgUploadSuccess(shopbusImgList,file)"
                            :data="qData"
                            :on-remove="(file, fileList)=>handleImgRemove(shopbusImgList,file)">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>

                <el-dialog :visible.sync="dialogVisible" append-to-body>
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogForm">取消</el-button>
                <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
                <el-button v-else type="primary" @click="updateData">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style type="stylus">
    .filter-container {
        /*padding-bottom: 20px;*/
    }

    .filter-item {
        margin-bottom: 10px;
    }

    .filter-item.input {
        /*line-height: 60px*/
        margin-right: 10px;
    }
</style>

<script>
    import {list, save, update, remove,updateMaterialPrice} from '@/api/shop'
    import waves from '@/directive/waves' // 水波纹指令

    import {getToken, domain} from '@/api/qiniu'
    import {listToStrs, strsToList} from '@/utils/imgUtil'

    import {mapGetters} from 'vuex'
    import {hasAuth} from '@/utils/auth'
    import {addressData} from '@/utils/area'

    export default {
        name: 'test',
        directives: {
            waves
        },
        data() {
            return {
                props: {
                    value: 'text',
                    label: 'text'
                },
                tableKey: 0,
                list: null,
                total: null,
                listLoading: true,
                listQuery: {
                    page: 1,
                    limit: 20,
                    order: 'id desc'
                    , name: null
                    , shopName: null
                    , mcode: null
                    , userCode: null
                    , status: null
                },
                statusOptions: ["待审核", "通过", "未通过"],
                typeOptions: ["否", "是"],
                tagTypes: ['info', '', 'warning', 'danger', 'warning'],
                selectedOptions: [],
                temp: {
                    id: null,
                    name: null,
                    avatar: null,
                    shopName: null,
                    shopAddress: null,
                    userAddress: null,
                    materialPrice: null,
                    card: null,
                    cardImg: null,
                    shopPhone: null,
                    userPhone: null,
                    managePhone: null,
                    slogan: null,
                    shopbusImg: null,
                    manageName: null,
                    mid: null,
                    userId: null,
                    status: null,
                    userCode:null,
                    mcode:null,
                    remark:null,
                    province:null,
                    city:null,
                    area:null,
                    type:null,
                    lng:null,
                    lat:null,
                    businessHours:null
                }
                ,
                dialogFormVisible: false,
                dialogStatus: '',
                textMap: {
                    update: '修改',
                    create: '新增'
                }
                ,
                // 存在图片
                dialogImageUrl: '',
                dialogVisible: false,
                avatarList: [],
                cardImgList: [],
                shopbusImgList: [],
                rules:
                    {
                        name: [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        lng: [
                            {
                                required: true,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        lat: [
                            {
                                required: true,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        avatar: [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        businessHours: [
                            {
                                required: true,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        shopName: [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        shopAddress: [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        userAddress: [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        card: [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        cardImg: [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        shopPhone: [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        userPhone: [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        managePhone: [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        slogan: [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        shopbusImg: [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        manageName: [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        mcode: [
                            {
                                required: true,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        userCode: [
                            {
                                required: true,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        status: [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'blur'
                            }
                        ]
                    }
                ,
                downloadLoading: false,
                qData:
                    {
                        token: '',
                        key: ''
                    }
            }
        },
        created() {
            this.getList()
        },
        computed: {
            ...mapGetters([
                'perms'
            ]),
            canSave() {
                return hasAuth(this.perms, 'shop:save')
            },
            canDelete() {
                return hasAuth(this.perms, 'shop:delete')
            },
            canUpdate() {
                return hasAuth(this.perms, 'shop:update')
            },
            canList() {
                return hasAuth(this.perms, 'shop:list')
            },
            addressData() {
                return addressData
            },
        },
        methods: {
            handleChange() {
                this.temp.province = null
                this.temp.city = null
                this.temp.area = null
                if (this.selectedOptions.length == 3){
                    this.temp.province = this.selectedOptions[0];
                    this.temp.city = this.selectedOptions[1];
                    this.temp.area = this.selectedOptions[2];
                }
                if (this.selectedOptions.length == 2){
                    this.temp.province = this.selectedOptions[0];
                    this.temp.city = this.selectedOptions[1];
                }
            },
            getList() {
                this.listLoading = true
                list(this.listQuery).then(response => {
                    this.list = response.data.list
                    this.total = response.data.total
                    this.listLoading = false
                })
            },
            handleFilter() {
                this.listQuery.page = 1
                this.getList()
            },
            handleSizeChange(val) {
                this.listQuery.limit = val
                this.getList()
            },
            handleCurrentChange(val) {
                this.listQuery.page = val
                this.getList()
            },
            handleModifyStatus(row, status) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                })
                row.status = status
            },
            beforeFormShow(row) {

                this.resetTemp(row) // 更新数据
                // 存在图片
                this.initQiniu()

                // 存在图片字段转换图片地址显示
                this.initImgUrl()
            },
            afterFormShow(row) {

            },
            beforeFormCommit() {
                this.initImgName()// 图片转换
            },
            resetTemp(row) {

                this.temp = {}
                this.selectedOptions = []
                if (row) {
                    this.temp = Object.assign({}, row) // copy obj
                    if (this.temp.province != null){
                        this.selectedOptions.push(this.temp.province)
                        this.selectedOptions.push(this.temp.city)
                        if (this.temp.area != null){
                            this.selectedOptions.push(this.temp.area)
                        }
                    }
                }
            },

            handleCreate() {
                this.beforeFormShow()
                this.resetTemp()
                this.dialogStatus = 'create'
                this.dialogFormVisible = true
                this.$nextTick(() => {
                    this.afterFormShow()
                    this.$refs['dataForm'].clearValidate()
                })
            },
            handleDelete(scope) {
                this.index = scope.$index
                // this.beforeFormShow(scope.row)
                // this.temp = Object.assign({}, row) // copy obj
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // this.$message({
                    //   type: 'success',
                    //   message: '删除成功!'
                    // })
                    this.deleteData()
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: '删除失败'
                    })
                })
            },
            // 显示将图片名封装成可以展示状态集合
            initImgUrl() {
                this.avatarList = strsToList(this.temp.avatar, domain)
                this.cardImgList = strsToList(this.temp.cardImg, domain)
                this.shopbusImgList = strsToList(this.temp.shopbusImg, domain)
            },
            // 关闭显示窗口 重置图片地址 防止错乱
            resetImgUrl() {
                this.avatarList = []
                this.cardImgList = []
                this.shopbusImgList = []
            },
            // 上传或者更新的时候从图片链接中获取图片名字
            initImgName() {
                this.temp.avatar = listToStrs(this.avatarList)
                this.temp.cardImg = listToStrs(this.cardImgList)
                this.temp.shopbusImg = listToStrs(this.shopbusImgList)
            },
            createData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            this.beforeFormCommit()
                            save(this.temp).then(res => {
                                this.temp = res.data
                                this.list.unshift(this.temp)
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '创建成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            deleteData() {
                // const ids = [this.temp.id]
                const ids = [this.list[this.index].id]
                remove({ids: ids}).then(res => {
                    // 从当前队列中移除
                    this.list.splice(this.index, 1)
                    this.$notify({
                        title: '成功',
                        message: '删除成功',
                        type: 'success',
                        duration: 2000
                    })
                })
            },
            handleUpdate(scope) {
                this.index = scope.$index
                this.beforeFormShow(scope.row)
                this.dialogStatus = 'update'
                this.dialogFormVisible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].clearValidate()
                })
            },
            updateData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            this.beforeFormCommit()
                            update(this.temp).then(() => {
                                this.list.splice(this.index, 1, this.temp)
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '更新成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            closeDialogForm() {
                // 存在图片
                this.resetImgUrl()
                this.selectedOptions =[]
                this.dialogFormVisible = false
            },
            handleDownload() {
                this.downloadLoading = true
                import('@/vendor/Export2Excel').then(excel => {
                    const tHeader = [
                        '序号'
                        ,
                        '店铺名'
                        ,
                        '店主姓名'
                        ,
                        '店铺地址'
                        ,
                        '店主地址'
                        ,
                        '店主身份证'
                        ,
                        '店铺联系方式'
                        ,
                        '店主联系电话'
                        ,
                        '管理者联系电话'
                        ,
                        '店铺标语'
                        ,
                        '管理者姓名'
                        ,
                        '管理者ID'
                        ,
                        '用户ID'
                        ,
                        '状态'
                    ]
                    const filterVal = ['id'
                        , 'name'
                        , 'shopName'
                        , 'shopAddress'
                        , 'userAddress'
                        , 'card'
                        , 'shopPhone'
                        , 'userPhone'
                        , 'managePhone'
                        , 'slogan'
                        , 'manageName'
                        , 'mid'
                        , 'userId'
                        ,
                        'status'
                    ]
                    const data = this.formatJson(filterVal, this.list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: 'table-list'
                    })
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => {
                        return v[j]
                    }
                ))
            },
            // 存在图片
            handleUpload(file) {
                this.qData.key = new Date().valueOf() + file.name
            },
            initQiniu() {
                // 获取七牛配置
                getToken().then(res => {
                    this.qData.token = res.data
                }).catch(error => {
                    console.log(error)
                })
            },
            handleImgUploadSuccess(imgList, file) {
                imgList.push({name: file.response.key, url: domain + file.response.key})
            },
            handleImgRemove(imgList, file) {
                for (var fn of imgList) {
                    if (fn.name === file.name) {
                        imgList.splice(imgList.indexOf(fn), 1)
                    }
                }
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url
                this.dialogVisible = true
            }
        }
    }
</script>
